import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_DescribeProjectVersionsCommand, se_DescribeProjectVersionsCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class DescribeProjectVersionsCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "DescribeProjectVersions", {})
    .n("RekognitionClient", "DescribeProjectVersionsCommand")
    .f(void 0, void 0)
    .ser(se_DescribeProjectVersionsCommand)
    .de(de_DescribeProjectVersionsCommand)
    .build() {
}
